<template>
  <Modal :name="$options.name"
         title="Jelszócsere">
    <template #body>
      <b-field label="Jelenlegi jelszó">
        <b-input v-model="form.currentPwd"
                 type="password"
                 password-reveal></b-input>
      </b-field>
      <b-field label="Új jelszó">
        <b-input v-model="form.newPwd"
                 type="password"
                 password-reveal></b-input>
      </b-field>
      <b-field label="Új jelszó megerősítés">
        <b-input v-model="form.newPwdConfirm"
                 type="password"
                 password-reveal></b-input>
      </b-field>
    </template>
    <template #footer>
      <b-button type="is-primary"
                @click="save">OK
      </b-button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/Modals/common/BasicModal'

export default {
  name: 'ChangePasswordModal',
  components: {
    Modal,
  },
  data () {
    return {
      form: {
        currentPwd: null,
        newPwd: null,
        newPwdConfirm: null,
      },
    }
  },
  methods: {
    // TODO: close modal clear form
    save () {
      alert(`save ${this.$options.name}`)
    },
  },
}
</script>

<style scoped>

</style>
